export default {
  init() {
    // console.log('pppp')
    // this.submitFormFilter();

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init function

  },

  /*submitFormFilter() {

    $(window).on('load', e => {
      const $themeSelector = $('#theme-selector');
      const $territorySelector = $('#territory-selector');
      const $editionSelector = $('#edition-selector');

      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if(!sParameterName[1].toLowerCase().includes('seleziona')) {
          if (sParameterName[0] === 'theme-selector') {
            sParameterName[1] === undefined ? true : $themeSelector.val(decodeURIComponent(sParameterName[1]));
          }
          if(sParameterName[0] === 'territory-selector') {
            sParameterName[1] === undefined ? true : $territorySelector.val(decodeURIComponent(sParameterName[1]));
          }
          if(sParameterName[0] === 'edition-selector') {
            sParameterName[1] === undefined ? true : $editionSelector.val(decodeURIComponent(sParameterName[1]));
          }
        }
      }
    });

  }, */

};
